'use strict';

angular.module('TurneroApp').component('coTurnoreimprimir', {
    controller: [
        'turnosService',
        '$anchorScroll',
        '$stateParams',
        '$window',
        'utilsService',
        'TRSService',
        function (turnosService, $anchorScroll, $stateParams, $window, utilsService, TRSService) {
            var ctrl = this;
            ctrl.Date = new Date();
            ctrl.reimprimir = new turnosService();
            ctrl.limpiarMemoria = function () {
                ctrl.reimprimir = new turnosService();
            }

            ctrl.identificadorTurno = function () {
                var turno = ctrl.reimprimir && ctrl.reimprimir.Turno ? ctrl.reimprimir.Turno : {};

                if (utilsService.tieneCuilParaMostrar(turno.N_Usuario_Cidi)) {
                    return "(CUIL " + turno.N_Usuario_Cidi + ")";
                }

                return turno.Nro_Documento ? "(DNI " + turno.Nro_Documento + ")" : "";
            };

            ctrl.obtenerDatosReimpresion = function (id_turno, desde_ciudadano = true) {
                utilsService.swalTitle('Obteniendo datos.', 'info');
                if ($window.location.search !== "") {
                    turnosService.Get_Reimpresion({ 'id_turno': id_turno, 'desde_ciudadano': desde_ciudadano }).$promise.then(function (data) {
                        ctrl.reimprimir = data.Data;
                        $anchorScroll();
                        swal.close();
                        setTimeout(function () {
                            $window.print();
                            $window.close();
                        }, 2500);
                    }).catch(function (error) {
                        utilsService.errores(error);
                    });
                }
                else {
                    turnosService.Get_Reimpresion_Agente({ 'id_turno': id_turno }).$promise.then(function (data) {
                        ctrl.reimprimir = data.Data;
                        $anchorScroll();
                        swal.close();
                        setTimeout(function () {
                            $window.print();
                            $window.close();
                        }, 2500);
                    }).catch(function (error) {
                        utilsService.errores(error);
                    });
                }

                TRSService.Get_Tasas_Turno({ 'id_turno': id_turno }).$promise.then(function (resultado) {
                    ctrl.tasasTurno = resultado.Data;
                    ctrl.TieneTasasRetributiva = ctrl.tasasTurno.length ? true : false;
                }).catch(function (error) {
                    utilsService.errores(error);
                });

            };

            ctrl.init = function () {
                console.log('stateParams')
                ctrl.obtenerDatosReimpresion($stateParams.Id_Turno, ($stateParams.Desde_Ciudadano == null ? true : $stateParams.Desde_Ciudadano));
            }



        }
    ],
    template: require('./turnoComprobante.html')
});



// WEBPACK FOOTER //
// ./app/components/turnos/turnoComprobanteComponent.js